import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('AbstractPerson')

export default {
  label: 'Externe Person',
  route: 'abstractperson',
  fields: [
    Filter.String('vorname'),
    Filter.String('name'),
    Filter.String('personIdentWert')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/AbstractPersonFilter.js